// frontend/src/pages/community360/ClubBills.jsx
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import './Community360.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';

const ClubBills = () => {
    const authState = useSelector(state => state.authReducer);
    const [myEnrollments, setMyEnrollments] = useState([]);
    const [workshops, setWorkshops] = useState([]);
    const [trainings, setTrainings] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedEnrollmentId, setSelectedEnrollmentId] = useState([]);

    const [selectedWorkshopId, setSelectedWorkshopId] = useState([]);
    const [selectedTrainingId, setSelectedTrainingId] = useState([]);
    const [showItineraryClicked, setShowItineraryClicked] = useState(false);
  
    const buttonStyle = {
      marginLeft: '10px',
      padding: '5px 10px',
      fontSize: '14px',
      cursor: 'pointer',
      borderRadius: '5px',
      border: 'none',
      backgroundColor: '#25D366',
      color: '#fff'
    };

    const fetchMyEnrollment = useCallback(() => {
        const config = { 
          url: "/trainingworkshop/myenrollment", 
          method: "post", 
          headers: { Authorization: authState.token }, 
          data: {user: authState.user._id}
        };
        // console.log("My Enrollments Config: ",config)
    
        fetchData(config, { showSuccessToast: false })
        .then(({ myenrollment }) => setMyEnrollments(myenrollment))
        .catch(error => console.error("Error fetching data:", error));
    
        }, [authState.token, fetchData]);
    
      useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchMyEnrollment();
      }, [authState.isLoggedIn, fetchMyEnrollment]);
  
    const sortedMyEnrollments = [...myEnrollments].sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated));

    const handleEnrollmentView = (_id) => {
        setSelectedEnrollmentId(prevId => (prevId === _id ? null : _id));
    };

    const fetchWorkshops = useCallback(() => {
      const config = { 
        url: "/trainingworkshop/workshoplist", 
        method: "get", 
        headers: { Authorization: authState.token } 
      };
    //   console.log("Training & Workshop Config: ",config)
  
      fetchData(config, { showSuccessToast: false })
      .then(({ workshops }) => setWorkshops(workshops))
      .catch(error => console.error("Error fetching data:", error));
  
      }, [authState.token, fetchData]);
  
    useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchWorkshops();
    }, [authState.isLoggedIn, fetchWorkshops]);
  
    const sortedWorkshops = [...workshops].sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
  
    const handleWorkshopView = (_id) => {
      setSelectedWorkshopId(prevId => (prevId === _id ? null : _id));
    };

    const fetchTrainings = useCallback(() => {
        const config = { 
          url: "/trainingworkshop/traininglist", 
          method: "get", 
          headers: { Authorization: authState.token } 
        };
        // console.log("Training Config: ",config)
    
        fetchData(config, { showSuccessToast: false })
        .then(({ trainings }) => setTrainings(trainings))
        .catch(error => console.error("Error fetching data:", error));
    
        }, [authState.token, fetchData]);
    
      useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchTrainings();
      }, [authState.isLoggedIn, fetchTrainings]);

      const sortedTrainings = [...trainings].sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));

    const handleTrainingView = (_id) => {
        setSelectedTrainingId(prevId => (prevId === _id ? null : _id));
    };
  
    // Call method
    const handleCallClick = (contactNumber) => {
      window.location.href = `tel:${contactNumber}`;
    };
  
    // WhatsApp method
    const handleWhatsAppClick = (contactNumber) => {
      const whatsappUrl = `https://wa.me/${contactNumber}`;
      window.open(whatsappUrl, '_blank');
    };
  
    // Email method
    const handleEmailClick = (contactEmail) => {
        window.location.href = `mailto:${contactEmail}`;
    };
    
    const handleItineraryClick = () => {
      setShowItineraryClicked(prevState => !prevState);
    };
  
    const formatDateTime = (date) => {
      const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
      };
      const jsDate = new Date(date);
      const day = jsDate.getDate().toString().padStart(2, '0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
      const year = jsDate.getFullYear();
      const hours = jsDate.getHours().toString().padStart(2, '0');
      const minutes = jsDate.getMinutes().toString().padStart(2, '0');
      const seconds = jsDate.getSeconds().toString().padStart(2, '0');
      return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    return (
        <MainLayout>
        <div className="my-1 mx-auto py-1 mt-12">
            <h2 className='text-lg mt-1 border-b border-b-gray-300 text-white'>Learnings - Training & Workshops</h2>
            <div className="text-white">
                <h1 className="ebooks-heading text-white"></h1>
                <div className='mt-4 flex justify-center'>
                    <Link to="/enroll/workshop" className="dukaan-button">Enroll For Workshop</Link>                    
                    <Link to="/enroll/training" className="amazon-button">Enroll For Training</Link>
                </div>
                <div className="my-2 mx-auto py-4">
                    {myEnrollments.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-yellow-300  border-b'>My Enrollments ({myEnrollments.length})</h2>}
                    {loading ? (
                    <Loader />
                    ) : (
                    <div className="flex flex-col text-purple-500 text-sm">
                        {myEnrollments.length === 0 ? (
                        <div className='my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>No enrollment found!!</div>
                        ) : (
                        sortedMyEnrollments.map((enrollment, index) => (
                            <div key={enrollment._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                            <div className='flex flex-row'>
                                <span>{index + 1}. </span> {enrollment.enrollmentNumber}
                                <Tooltip text={"View details"} position={"top"}>
                                <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleEnrollmentView(enrollment._id)}>
                                    <i className="fa-solid fa-eye"></i>
                                </span>
                                </Tooltip>
                            </div>
                            {selectedEnrollmentId === enrollment._id && (
                                <div className='bg-gray-200 text-black'>
                                <p className='text-blue-500'><strong>Enrollment Number:</strong>{enrollment.enrollmentNumber}</p>
                                <p><strong>{enrollment.isTraining ? "Training" : "Workshop"}</strong></p>
                                <p><strong>{enrollment.title}</strong></p>
                                <p><strong>Enrollment Date:</strong> {formatDateTime(enrollment.dateCreated)}</p>
                                <p><strong>Remarks:</strong> {enrollment.enrollmentRemarks}</p>
                                <p><strong>Payment Date:</strong>{formatDateTime(enrollment.paymentDate)}</p>
                                <p><strong>Amount:</strong>{enrollment.amount}</p>
                                <p><strong>{enrollment.isPaid? "Paid": "Payment is Due"}</strong></p>
                                <p><strong>Payment Mode:</strong>{enrollment.paymentMode}</p>
                                <p><strong>Payment Remarks:</strong>{enrollment.paymentRemarks}</p>
                            </div>
                            )}
                            </div>
                        ))
                        )}
                    </div>
                    )}
                </div>
                <div className="my-2 mx-auto max-w-[700px] py-4">
                    {workshops.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-yellow-300  border-b'>Workshop List ({workshops.length})</h2>}
                    {loading ? (
                    <Loader />
                    ) : (
                    <div className="flex flex-col text-purple-500 text-sm">
                        {workshops.length === 0 ? (
                        <div className='my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>Currently there is no Live Workshops!!</div>
                        ) : (
                        sortedWorkshops.map((workshop, index) => (
                            <div key={workshop._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                            <div className='flex flex-row'>
                                <span>{index + 1}. </span> {workshop.title}
                                <Tooltip text={"View details"} position={"top"}>
                                <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleWorkshopView(workshop._id)}>
                                    <i className="fa-solid fa-eye"></i>
                                </span>
                                </Tooltip>
                            </div>
                            {selectedWorkshopId === workshop._id && (
                                <div className='bg-gray-200 text-black'>
                                <p className='text-blue-500'><strong>Event Title:</strong>{workshop.title}</p>
                                <p><strong>Objective:</strong>{workshop.objective}</p>
                                <p><strong>From Date:</strong> {formatDateTime(workshop.fromDate)}</p>
                                <p><strong>To Date:</strong> {formatDateTime(workshop.toDate)}</p>
                                <p><strong>Timing:</strong>{workshop.timing}</p>
                                <p><strong>Venue:</strong>{workshop.venue}</p>
                                <p><strong>Trainer:</strong>{workshop.trainerName}</p>
                                <p><strong>Remarks:</strong>{workshop.remarks}</p>
                                <p><strong>Fee:</strong>{workshop.feeDetails}</p>
                                {workshop.showItinerary && (
                                    <>
                                    <p>
                                        <button 
                                        onClick={() => handleItineraryClick()} 
                                        style={buttonStyle}
                                        >
                                        📅 Show Itinerary
                                        </button>
                                    </p>
                                    {showItineraryClicked && (
                                        <div className='border-1 bg-lime-100' dangerouslySetInnerHTML={{ __html: workshop.itinerary }} />
                                    )}
                                    </>
                                )}
                                <p><strong>Current Status:</strong>{workshop.currentStatus}</p>
                                <p><strong>Enroll Now:</strong>{workshop.enrollNow ? "Yes" : "No"}</p>
                                <p><strong>Payment Method:</strong>{workshop.paymentMethod}</p>
                                <p><strong>Contact Person / Organisor: </strong> {workshop.contactPerson}</p>
                                <p>
                                    <button onClick={() => handleCallClick(workshop.contactNumber)} style={buttonStyle}>
                                    📞 Call
                                    </button>
                                    <button onClick={() => handleWhatsAppClick(workshop.contactNumber)} style={buttonStyle}>
                                    💬 WhatsApp
                                    </button>
                                    <button onClick={() => handleEmailClick(workshop.contactEmail)} style={buttonStyle}>
                                        ✉️ Email
                                    </button>
                                </p>
                                </div>
                            )}
                            </div>
                        ))
                        )}
                    </div>
                    )}
                </div>
                <div className="my-2 mx-auto max-w-[700px] py-4">
                    {trainings.length !== 0 && <h2 className='my-2 ml-2 md:ml-0 text-yellow-300  border-b'>Training List ({trainings.length})</h2>}
                    {loading ? (
                    <Loader />
                    ) : (
                    <div className="flex flex-col text-purple-500 text-sm">
                        {trainings.length === 0 ? (
                        <div className='my-4 p-4 text-yellow-300 text-lg rounded-md shadow-md border-b-2'>Currently there is No Training!!</div>
                        ) : (
                        sortedTrainings.map((training, index) => (
                            <div key={training._id} className='bg-white my-1 p-4 text-gray-600 rounded-md shadow-md'>
                            <div className='flex flex-row'>
                                <span>{index + 1}. </span> {training.title}
                                <Tooltip text={"View details"} position={"top"}>
                                <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleTrainingView(training._id)}>
                                    <i className="fa-solid fa-eye"></i>
                                </span>
                                </Tooltip>
                            </div>
                            {selectedTrainingId === training._id && (
                                <div className='bg-gray-200 text-black'>
                                <p className='text-blue-500'><strong>Title:</strong>{training.title}</p>
                                <p><strong>Objective:</strong>{training.objective}</p>
                                <p><strong>From Date:</strong> {formatDateTime(training.fromDate)}</p>
                                <p><strong>To Date:</strong> {formatDateTime(training.toDate)}</p>
                                <p><strong>Timing:</strong>{training.timing}</p>
                                <p><strong>Venue:</strong>{training.venue}</p>
                                <p><strong>Trainer:</strong>{training.trainerName}</p>
                                <p><strong>Remarks:</strong>{training.remarks}</p>
                                <p><strong>Fee:</strong>{training.feeDetails}</p>
                                {training.showItinerary && (
                                    <>
                                    <p>
                                        <button 
                                        onClick={() => handleItineraryClick()} 
                                        style={buttonStyle}
                                        >
                                        📅 Show Itinerary
                                        </button>
                                    </p>
                                    {showItineraryClicked && (
                                        <div className='border-1 bg-lime-100' dangerouslySetInnerHTML={{ __html: training.itinerary }} />
                                    )}
                                    </>
                                )}
                                <p><strong>Current Status:</strong>{training.currentStatus}</p>
                                <p><strong>Enroll Now:</strong>{training.enrollNow ? "Yes" : "No"}</p>
                                <p><strong>Payment Method:</strong>{training.paymentMethod}</p>
                                <p><strong>Contact Person / Organisor: </strong> {training.contactPerson}</p>
                                <p><strong>Email:</strong>{training.contactEmail}</p>
                                <p>
                                    <button onClick={() => handleCallClick(training.contactNumber)} style={buttonStyle}>
                                    📞 Call
                                    </button>
                                    <button onClick={() => handleWhatsAppClick(training.contactNumber)} style={buttonStyle}>
                                    💬 WhatsApp
                                    </button>
                                    <button onClick={() => handleEmailClick(training.contactEmail)} style={buttonStyle}>
                                        ✉️ Email
                                    </button>
                                </p>
                                </div>
                            )}
                            </div>
                        ))
                        )}
                    </div>
                    )}
                </div>
            </div>
        </div>
        </MainLayout>
    );
};

export default ClubBills;
